import { useState, useMemo, useEffect, useCallback } from "react";
import cookie from "js-cookie";
import postMessage from "../helpers/PostMessage";
import { useNavigate } from "react-router-dom";

const useAuth = () => {
  const [isAuth, setIsAuth] = useState(false);
  const [userProfile, setUserProfile] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    // 1. รับ token จาก URL param ?token=xxx (สำหรับ dev testing)
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get("token");

    if (urlToken) {
      try {
        // Decode JWT payload เพื่อดึง name/email จาก Azure AD
        const base64Payload = urlToken.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        const payload = JSON.parse(atob(base64Payload));
        const email = payload.upn || payload.unique_name || payload.email || "";
        const name = payload.name || payload.given_name || "";

        // รับ userId จาก URL param ?userId=1070 (internal userId จาก backend)
        const urlUserId = urlParams.get("userId") || "";

        const userProfile = {
          userId: urlUserId,
          name,
          email,
        };
        cookie.set("token", urlToken);
        cookie.set("userId", urlUserId);
        cookie.set("userProfile", JSON.stringify(userProfile));
        setUserProfile(userProfile);
        setIsAuth(true);
        return;
      } catch (error) {
        console.warn("[AutoLogin] URL token decode failed:", error);
      }
    }

    // 2. Dev mode auto-login fallback (ไม่มี URL token)
    if (process.env.REACT_APP_DEV_AUTO_LOGIN === "true" && !cookie.get("token")) {
      const mockProfile = {
        userId: "1070",
        name: "payment02",
        email: "payment02@becworld.com",
      };
      cookie.set("userId", mockProfile.userId);
      cookie.set("userProfile", JSON.stringify(mockProfile));
      setUserProfile(mockProfile);
      setIsAuth(true);
      return;
    }

    // 3. Cookie-based auth (production / native app)
    if (cookie.get("token")) {
      setIsAuth(true);
    }
    const userProfile = cookie.get("userProfile");
    if (userProfile) {
      setUserProfile(JSON.parse(userProfile));
    }
  }, []);

  const login = useCallback(
    async message => {
      try {
        await logoutSuccess();
        const { accessToken, userProfile } = message.data;
        setUserProfile(userProfile);
        cookie.set("token", accessToken);
        cookie.set("userId", userProfile.userId);
        setIsAuth(true);
        cookie.set("userProfile", JSON.stringify(userProfile));
        if (window.location.pathname === "/profile") {
          navigate("/");
        }
      } catch (error) { }
    },
    [navigate]
  );

  const logout = async () => {
    try {
      postMessage({
        type: "logout"
      });
    } catch (error) { }
  };

  const logoutSuccess = async () => {
    cookie.remove("token");
    cookie.remove("tokenDate");
    cookie.remove("userId");
    setIsAuth(false);
    setUserProfile({});
  };

  useEffect(() => {
    setTimeout(() => {
      postMessage({
        type: process.env.REACT_APP_SESSION_EXPIRED
      });
    }, 5000);
  }, [])

  const value = useMemo(
    () => ({ isAuth, login, logout, userProfile, logoutSuccess }),
    [isAuth, userProfile, login]
  );
  return value;
};

export default useAuth;
